function getPathState(path) {
  return this.state.paths.get(path);
}
module.exports = getPathState;
